import { Component } from '@opten/gin-tonic/helpers/compiler';
import mixitup from 'mixitup';
import mixitupPagination from '../../../libs/mix-it-up-pagination/mixitup-pagination.min.js';
import mixitupMultifilter from '../../../libs/mix-it-up-multifilter/mixitup-multifilter.min.js';
import { toggleClass } from '../../../libs/gin-tonic/helpers/dom/toggle-class/index';

mixitup.use(mixitupPagination);
mixitup.use(mixitupMultifilter);

@Component({ className: 'js-filter' })
export class FilterComponent {
	private loadMore: HTMLElement;
	private emptyState: HTMLElement;
	private mixer: any;
	private currentLimmit: number = 12;
	private incrementAmount: number = 12;
	private search: HTMLInputElement;
	constructor(private element: HTMLElement) {
		this.loadMore = this.element.querySelector('.js-load-more') as HTMLElement;
		this.search = element.querySelector('.js-filter-search') as HTMLInputElement;
		this.emptyState = element.querySelector('.js-filter-empty-state') as HTMLElement;
		if (this.search) {
			this.search.value = '';
		}
		this.mixer = mixitup(this.element, {
			selectors: {
				target: '.js-filter-item',
				control: '.js-filter-control'
			},
			multifilter: {
				enable: true,
				parseOn: 'change'
			},
			pagination: {
				limit: this.currentLimmit
			},
			animation: {
				duration: 300
			},
			controls: {
				toggleLogic: 'and'
			},
			callbacks: {
				onParseFilterGroups: command => {
					if (command.filter.selector.indexOf('all[') != -1) {
						command.filter.selector = command.filter.selector.replace('all[' ,'.js-filter-item[');
					}
					return command;
				},
				onMixStart: (state, futureState) => {
					this.toggleEmptyState(futureState.totalShow > 0);
				},
				onMixEnd: state => {
					this.handleMixEnd(state);
					this.toggleEmptyState(state.totalShow > 0);
				}
			}
		});
		this.loadMore.addEventListener('click', () => this.loadMoreItems());
	}

	private handleMixEnd(state: any) {
		toggleClass(this.loadMore, 'd-none', this.currentLimmit >= state.totalMatching);
	}

	private loadMoreItems() {
		this.currentLimmit += this.incrementAmount;
		this.mixer.paginate({ limit: this.currentLimmit });
	}

	private toggleEmptyState(show = false) {
		if (this.emptyState) {
			toggleClass(this.emptyState, 'd-none', show);
		}
	}
}
